/* Rive interactions. Shopify's Google pixel owns page views and ecommerce events. */
(() => {
  'use strict';

  const measurementId = 'G-49F3D2PD06';
  const pendingKey = 'rive_analytics_pending_lead';

  // Shopify loads this API on demand. The Google tag itself is already installed.
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }

  function publish(name, parameters) {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() && typeof window.gtag === 'function') {
      window.gtag('event', name, { ...parameters, send_to: measurementId });
    }
  }

  function placement(element) {
    const locations = [
      ['.rive-home__hero', 'home_hero'],
      ['.rive-home__collection', 'home_collection'],
      ['.rive-home__atelier', 'home_atelier'],
      ['.rive-home__attentions', 'home_attentions'],
      ['.rive-home__journal', 'home_journal'],
      ['.rive-collection', 'collection'],
      ['.rive-product-detail', 'product_detail'],
      ['.rive-blog', 'blog'],
      ['#header-group', 'header'],
      ['.rive-footer', 'footer']
    ];
    const match = locations.find(([selector]) => element.closest(selector));
    return match ? match[1] : 'page';
  }

  function trackLink(anchor) {
    let destination;
    try {
      destination = new URL(anchor.href, window.location.href);
    } catch (_) {
      return;
    }
    if (destination.origin !== window.location.origin ||
        !/^\/(collections|products|blogs|pages)\//.test(destination.pathname)) return;

    const path = destination.pathname.replace(/\/$/, '');
    const group = path.split('/')[1];
    const contentType = group === 'blogs'
      ? (path.split('/').length > 3 ? 'article' : 'journal')
      : group === 'pages' && path === '/pages/guide-des-tailles'
        ? 'size_guide'
        : group === 'pages' && path === '/pages/contact'
          ? 'contact'
          : group.slice(0, -1);

    publish('select_content', {
      content_type: contentType,
      item_id: path,
      placement: placement(anchor),
      destination_path: path
    });
  }

  function rememberLead(kind) {
    try {
      sessionStorage.setItem(pendingKey, JSON.stringify({ kind, at: Date.now() }));
    } catch (_) { /* Storage can be unavailable in private browsing. */ }
  }

  function readPendingLead() {
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending || Date.now() - pending.at > 10 * 60 * 1000) return null;
      return pending;
    } catch (_) {
      return null;
    }
  }

  function clearPendingLead() {
    try { sessionStorage.removeItem(pendingKey); } catch (_) { /* noop */ }
  }

  function trackSuccessfulLead() {
    const pending = readPendingLead();
    if (!pending) return;

    const newsletter = document.querySelector(`[data-rive-lead-success="${pending.kind}"]`);
    const contactSuccess = pending.kind === 'contact' &&
      new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    if (!newsletter && !contactSuccess) return;

    clearPendingLead();
    if (pending.kind.startsWith('newsletter')) {
      publish('newsletter_signup', {
        form_location: pending.kind.replace('newsletter_', ''),
        method: 'form'
      });
    } else {
      publish('generate_lead', {
        lead_source: 'contact',
        form_location: 'contact_page',
        method: 'form'
      });
    }
  }

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor && anchor.matches(
      '.rive-button, .rive-text-link, .rive-product-card, ' +
      '.rive-home__article a, .rive-blog__card a, .rive-product-detail__grid a, ' +
      '#header-group a'
    )) trackLink(anchor);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('.rive-home__newsletter-form')) rememberLead('newsletter_home');
    else if (form.matches('.rive-footer__newsletter-form')) rememberLead('newsletter_footer');
    else if (form.matches('.contact-form__form')) rememberLead('contact');
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackSuccessfulLead, { once: true });
  } else {
    trackSuccessfulLead();
  }
})();
